export default __webpack_public_path__ + "src/download/modeloDeExclusao.csv";